import React from 'react';
import { observer } from 'mobx-react-lite';
import { useInfiniteAPI } from 'polotno/utils/use-api';

import { SectionTab } from 'polotno/side-panel';
import MdPhotoLibrary from '@meronex/icons/md/MdPhotoLibrary';
import MdFolder from '@meronex/icons/md/MdFolder';

import { ImagesGrid } from 'polotno/side-panel/images-grid';

export const TemplatesPanel = observer(({ store }) => {
  // load data
  const { data, isLoading } = useInfiniteAPI({
    getAPI: ({ page }) => `templates-bse/page${page}.json`,
  });

  return (
    <div class='custom-templates-bse' style={{ height: '100%' }}>
      <ImagesGrid
        shadowEnabled={true}
        images={data?.map((data) => data.items).flat()}
        getPreview={(item) => `templates-bse/${item.preview}`}
        isLoading={isLoading}
        onSelect={async (item) => {
          // download selected json
          const req = await fetch(`templates-bse/${item.json}`);
          const json = await req.json();
          // just inject it into store
          store.loadJSON(json);
        }}
        rowsNumber={2}
      />
    </div>
  );
});

// define the new custom section
export const TemplatesSectionBse = {
  name: 'custom-templates-bse',
  Tab: (props) => (
    <SectionTab name="Bse" {...props}>
          <div
            style={{
              maxWidth: '200px',
            }}
          >
            <img
              src="bse.svg"
	  		  alt="Bet Shemesh Express"
	  		  style={{
              height: '36px',
              maxWidth: '200px',
              }}
            />
          </div>
    </SectionTab>
  ),
  // we need observer to update component automatically on any store changes
  Panel: TemplatesPanel,
};
